module.exports = __webpack_public_path__ + "49c0f03ec2fa354df7002bcb6331e106.ttf";